import View from './view';
import {Props} from './model';
import {RegExps} from '../../../../shared/constants/regexps';
import {useQrCodeScanner} from '../../../../shared/hooks/useQrCodeScanner';

export const QrCodeIcon = ({onScan, adjustFor}: Props) => {
  const runScanner = useQrCodeScanner({
    onComplete: onScan,
    validation: RegExps.checkEsksoCardNumberByScan,
  });

  return View({onPress: runScanner, adjustFor});
};
